var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"far fa-question-circle o70 help-tip"})
}
var staticRenderFns = []

export { render, staticRenderFns }